"use client";

import type { Category } from "@/types";

import ClientNavigation from "./ClientNavigation";
import NavWrapper from "./NavWrapper";

type Props = {
	initialNavCategories?: Category[];
};

export default function ClientNavigationShell({ initialNavCategories = [] }: Props) {
	return (
		<NavWrapper>
			<ClientNavigation initialNavCategories={initialNavCategories} />
		</NavWrapper>
	);
}
